import React from "react";

import { OrganizationUser, User } from "chq";

import { makePatch } from "@culturehq/client";
import { Button } from "@culturehq/components";

import { Trans } from "app/utils";

interface UserWithoutOrganizationRowProps {
  onFetch: () => void;
  user: User;
}

const UserWithoutOrganizationRow = ({ onFetch, user }: UserWithoutOrganizationRowProps) => {
  const { name, email, organizationUsers } = user;

  const handleSelectOrganization = (organizationUser: OrganizationUser) => {
    makePatch(`/organization_users/${organizationUser.id}`).then(onFetch);
  };

  return (
    <tr>
      <td>
        <Trans>{name}</Trans>
      </td>
      <td>
        <Trans>{email}</Trans>
      </td>
      <td className="Actions-column">
        {organizationUsers?.map(organizationUser => (
          <Button inverted onClick={() => { handleSelectOrganization(organizationUser); }}>
            <Trans>Select</Trans>{" "}{organizationUser.organization.name}
          </Button>
        ))}
      </td>
    </tr>
  );
};

export default UserWithoutOrganizationRow;
